@for (partModel of partModelList(); track partModel.uuid) {
  <button
    class="relative isolate flex-none flex flex-col justify-end ring-[#0047FF] duration-200 rounded w-full h-1/3 overflow-hidden disabled:animate-pulse"
    [ngClass]="{ 'ring-2': partModel.isSelected, 'ring-0': !partModel.isSelected }"
    (click)="onClickPart(partModel)"
    [disabled]="isLoading"
  >
    <div
      class="absolute right-2 top-2 flex h-4 w-4 flex-none items-center justify-center rounded-full border duration-200 z-10"
      [ngClass]="{
        'bg-[#0047FF] text-white': partModel.isSelected,
        'bg-none text-white/60': !partModel.isSelected,
      }"
    >
      <svg class="h-2.5 w-2.5" viewBox="0 0 12 10">
        <polyline
          fill="none"
          stroke-width="2px"
          stroke="currentColor"
          stroke-dasharray="16px"
          points="1.5 6 4.5 9 10.5 1"
        ></polyline>
      </svg>
    </div>
    <img
      [src]="partModel.thumbnail"
      alt="University of Southern California"
      class="absolute inset-0 h-full w-full object-cover"
    />
    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
    <h3 class="z-10 mb-2 px-1 text-[0.625rem] font-bold text-white">{{ partModel.title }}</h3>
  </button>
}
